/**
 * The propers corpus, built once at module load.
 *
 * Same bargain as `data/hymnal.ts`: the datasets compile into THIS bundle,
 * which is only ever fetched by someone already on a `/hymnal/*` page, so the
 * marketing site never pays for them. The two maps are ~160KB and ~190KB of
 * JSON against the hymnal's 469KB, a small addition to a bundle that already
 * accepted the trade.
 *
 * Indexing is deterministic and pure, so building at module scope is safe in
 * SSR and in the browser alike and both produce byte-identical output, which is
 * what keeps hydration from mismatching.
 *
 * TWO BOOKS, ONE PAGE PER DAY. The American Gradual carries introits,
 * offertories and communions; the Gradual Psalms carry the gradual psalms and
 * the alleluia verses. Neither is a complete set of propers on its own, and a
 * musician planning a Sunday wants all of them at once, so `indexProperBooks`
 * merges them on `dayId`. ORDER MATTERS HERE: the first book to set a day
 * supplies its title and section.
 */
import americanGradual from '@gjl/music-manager/data/propers/american-gradual.json'
import gradualPsalms from '@gjl/music-manager/data/propers/gradual-psalms.json'

import { indexProperBooks, type ProperBook } from '@/lib/propers'

// A single annotation, no cast: `ProperBook` describes the extractors' JSON as
// it actually is, and the model narrows `rite` and `years` on the way out. Both
// shapes are verified by `propers.test.ts`, which runs these exact files
// through `indexProperBooks` rather than a fixture.
export const AMERICAN_GRADUAL: ProperBook = americanGradual
export const GRADUAL_PSALMS: ProperBook = gradualPsalms

export const BOOKS = [AMERICAN_GRADUAL, GRADUAL_PSALMS]

export const index = indexProperBooks(...BOOKS)
